import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { useSetBulkIssuesList } from '../providers/BulkCreateContextProvider.tsx';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider.tsx';
import { useAiBulkNavigationGotoPage } from '../providers/AiBulkNavigationContextProvider.tsx';

import { mapActionItemsToIssues } from './actionItemUtils.tsx';

export const useMapActionItemsToIssues = () => {
	const [{ selectedActionItems }] = useIssueCreateSidePanelContext();
	const setBulkIssuesList = useSetBulkIssuesList();
	const goToPage = useAiBulkNavigationGotoPage();
	useEffect(() => {
		if (selectedActionItems && fg('confluence-create-work-items-from-action-items')) {
			const mappedIssues = mapActionItemsToIssues(selectedActionItems);
			void setBulkIssuesList(mappedIssues);
			if (mappedIssues.length === 0) {
				void goToPage('configure');
			}
		}
	}, [goToPage, setBulkIssuesList, selectedActionItems]);
};
